import React from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import classes from '../../css/getCSS';


const formErrorDialog = (props) => {
  return (
    <Dialog
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      classes={{
        paper: classes.dialogCard,
      }}
    >
      <DialogTitle id="alert-dialog-title">Error!</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          There is an error. <br />
          Please check for any error messages in the page or any fields marked in red color.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.handleClose} color="primary" autoFocus>OK</Button>
      </DialogActions>
    </Dialog>
  );
};


export default formErrorDialog;



// WEBPACK FOOTER //
// ./src/common/components/formErrorDialog.js